import React from 'react';

function SearchSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        fill="currentColor"
        d="M19.774 18.72L15.9 14.845a8.978 8.978 0 002.146-5.826C18.047 4.046 14 0 9.027 0 4.053 0 .007 4.046.007 9.02c0 4.973 4.046 9.02 9.02 9.02a8.973 8.973 0 005.813-2.133l3.874 3.873a.748.748 0 001.06 0 .75.75 0 000-1.06zM1.508 9.02c0-4.146 3.373-7.52 7.52-7.52 4.147 0 7.52 3.373 7.52 7.52 0 2.07-.841 3.947-2.198 5.308l-.016.01c-.004.004-.005.009-.008.013a7.492 7.492 0 01-5.297 2.188c-4.148 0-7.521-3.374-7.521-7.52z"
      ></path>
    </svg>
  );
}

export default SearchSvg;
